/**
 * Provides logic to hide or show the loading panel based on the application state.
 */
export const loadingPanelServiceModule = angular
  .module('Q.services.loading-panel', [])

  .run(function ($rootScope) {
    $rootScope.showLoadingPanel = false;
    let error = false;

    const showPanel = ($event, options = {}) => {
      if (!error && options.showLoadingPanel !== false) {
        $rootScope.showLoadingPanel = true;
      }
    };
    const hidePanel = () => ($rootScope.showLoadingPanel = false);
    const errorPanel = () => {
      error = true;
      hidePanel();
    };

    $rootScope.$on('app.checkingLogin', showPanel);
    $rootScope.$on('app.login', showPanel);
    $rootScope.$on('app.logout', showPanel);
    $rootScope.$on('$stateChangeSuccess', hidePanel);
    $rootScope.$on('app.error', errorPanel);
  });
